var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPlaya(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4334",
    "data-name": "Group 4334",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.422,
    height: 25.992,
    viewBox: "0 0 27.422 25.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #002e6b;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3660",
    "data-name": "Rectangle 3660",
    className: "cls-1",
    width: 27.423,
    height: 25.992
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4323",
    "data-name": "Group 4323",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7522",
    "data-name": "Path 7522",
    className: "cls-1",
    d: "M18.5,113.691a21.144,21.144,0,0,0-8.541-1.79L.012,111.89,0,110.8l9.945-.01-2.7-8.23L.6,104.96a.344.344,0,0,1-.4-.31l.671-4.387,3.7-4.886c.118-.156.548-.134.726-.107l6.062.929c1.414.935,2.919,1.834,4.343,2.672a.451.451,0,0,1,.109.419.658.658,0,0,1-.335.279l-7.233,2.61,2.84,8.636a24.691,24.691,0,0,1,5.449.963,17.125,17.125,0,0,1,2.509,1.01ZM13.771,99.008l-2.815-1.762-4.947-.732,2.74,4.323Zm-12.3,4.454,6.23-2.252L4.864,96.8,1.874,100.7Z",
    transform: "translate(0 -87.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7523",
    "data-name": "Path 7523",
    className: "cls-1",
    d: "M236.113,41.576a3.116,3.116,0,1,1-2.776-3.691,3.129,3.129,0,0,1,2.776,3.691m-1.052-.246a2.035,2.035,0,0,0-1.9-2.368,2.075,2.075,0,0,0-.2,4.146,2.03,2.03,0,0,0,2.1-1.777",
    transform: "translate(-211.708 -34.868)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7524",
    "data-name": "Path 7524",
    className: "cls-1",
    d: "M166.11,251.587a1.483,1.483,0,0,0-2.25,0,2.413,2.413,0,0,1-3.512.008,1.642,1.642,0,0,0-1.047-.538,1.769,1.769,0,0,0-1.222.542,2.585,2.585,0,0,1-3.286.3l.539-.881a1.64,1.64,0,0,0,2.106-.294,2.455,2.455,0,0,1,3.543.015,1.656,1.656,0,0,0,1.057.534,1.6,1.6,0,0,0,1.141-.512,2.431,2.431,0,0,1,3.532-.041,1.5,1.5,0,0,0,1.924.333,2.807,2.807,0,0,1,.523.885,2.312,2.312,0,0,1-3.047-.342",
    transform: "translate(-142.521 -230.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7525",
    "data-name": "Path 7525",
    className: "cls-1",
    d: "M263.587,2.052l-1.052.011,0-2.063,1.048,0Z",
    transform: "translate(-241.718)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7526",
    "data-name": "Path 7526",
    className: "cls-1",
    d: "M263.59,131.264h-1.058v-2.04l1.044-.006Z",
    transform: "translate(-241.717 -118.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7527",
    "data-name": "Path 7527",
    className: "cls-1",
    d: "M301.626,20.689l-.766-.719,1.405-1.429.751.742Z",
    transform: "translate(-277.006 -17.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7528",
    "data-name": "Path 7528",
    className: "cls-1",
    d: "M211.072,111.807l-.763-.739,1.4-1.428.757.744Z",
    transform: "translate(-193.635 -100.948)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7529",
    "data-name": "Path 7529",
    className: "cls-1",
    d: "M322.19,72l-2.04.009.02-1.075h2.014Z",
    transform: "translate(-294.767 -65.306)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7530",
    "data-name": "Path 7530",
    className: "cls-1",
    d: "M194.977,71.942l-2.022.006-.015-1.07,2.018-.01Z",
    transform: "translate(-177.642 -65.249)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7531",
    "data-name": "Path 7531",
    className: "cls-1",
    d: "M211.857,20.6l-1.412-1.406.73-.759,1.428,1.416Z",
    transform: "translate(-193.76 -16.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7532",
    "data-name": "Path 7532",
    className: "cls-1",
    d: "M302.207,111.934l-1.409-1.422.754-.744,1.4,1.4Z",
    transform: "translate(-276.95 -101.065)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlaya);
export default __webpack_public_path__ + "static/media/Icon_playa.aa7ce71a5302798c7994b90466ffea5f.svg";
export { ForwardRef as ReactComponent };